// SelectedColumnsTree.jsx
import React from 'react';
import SelectedTreeNode from '../SelectedTreeNode/SelectedTreeNode';
import useTrimStore from '../../store/trimStore';

const SelectedColumnsTree = () => {
  const { terminalNodes, selectedTreeData, toggleSelectedNode, selectedCheckedNodes } = useTrimStore();


  // console.log('🔥 [DEBUG] SelectedColumnsTree 렌더링');
  // console.log('🔥 [DEBUG] terminalNodes:', terminalNodes);
  // console.log('🔥 [DEBUG] selectedTreeData:', selectedTreeData);

  // terminalNodes가 없으면 아무것도 렌더링하지 않음
  if (!terminalNodes || terminalNodes.length === 0) {
    console.log('🔥 [DEBUG] SelectedColumnsTree - terminalNodes 없음');
    return <div>선택된 터미널 노드가 없습니다.</div>;
  }

  if (!selectedTreeData) {
    console.log('🔥 [DEBUG] SelectedColumnsTree - selectedTreeData 없음');
    return <div>선택된 트리 데이터가 없습니다.</div>;
  }



  return (
    <div>
      <SelectedTreeNode 
        node={selectedTreeData} 
        isRoot={true}
        onToggle={toggleSelectedNode}
        checkedNodes={selectedCheckedNodes}
      />
    </div>
  );
};

export default SelectedColumnsTree;